import request from '@/utils/requestLongTime'
import requestNoToken from '@/utils/requestNoToken'
import Qs from 'qs'
export function getUserInfo(userId) {
  return request({
    url: '/address/getUserInfo',
    method: 'get',
    params: {userId}
  })
}

export function updateUserInfo(data) {
  return request({
    url: '/address/updateUserInfo',
    method: 'post',
    data
  })
}

export function getAddressInfo(userId) {
  return request({
    url: '/address/getAddressInfo',
    method: 'get',
    params: {userId}
  })
}


export function updateAddressInfo(data) {
  return request({
    url: '/address/updateAddress',
    method: 'post',
    data
  })
}
export function unbindGoogleById(userId) {
  return request({
    url: '/auth/unbindGoogleById',
    method: 'get',
    params: {userId}
  })
}

export function unbindFacebookById(userId) {
  return request({
    url: '/auth/unbindFacebookById',
    method: 'get',
    params: {userId}

  })
}

export function updateUserEmail(data) {
  return request({
    url: '/address/updateUserEmail',
    method: 'post',
    data
  })
}

export function updateUserPassword(data) {
  return request({
    url: '/address/updateUserPassword',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/auth/resetPassword',
    method: 'post',
    data
  })
}

export function setNewPassword(data) {
  return request({
    url: '/auth/setNewPassword',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/userProfile.js